'use strict';

var _ = require('lodash');
var LatestAtpcoTransmissionTimeService = function LatestAtpcoTransmissionTimeService(momentService, $filter, restangular, featureToggleService) {
  var rmMomentFormat = $filter('rmMomentFormat');
  function getLatestAtpcoTranmissionTime() {
    var NO_OF_DAYS_TO_QUERY = 2;
    var restmqCreationDate = new Date();
    restmqCreationDate.setDate(restmqCreationDate.getDate() - NO_OF_DAYS_TO_QUERY);
    var queueName = 'NGDSFaresOptimizerTrigger';
    if (featureToggleService.isEnabled('FETCH_FARES_FROM_LAKE')) {
      queueName = 'NGDSDeltaLakeFaresOptimizerTrigger';
    }
    return restangular.one('queue').one(queueName).one('messages').get({
      filter: 'creationDate>=' + momentService.of(restmqCreationDate, momentService.TYPE.LOCAL_DATE_TIME).toString()
    }).then(function (data) {
      var latestCompletedTransmissionDateTime = _.chain(data).filter(getSuccessfullyProcessedMessages).map('events[0].eventTransmissionDateTime').map(getMomentFromEventTransmissionDateTimeString).sort().last().value();
      return !latestCompletedTransmissionDateTime ? '' : getAtpcoDateTimeString(latestCompletedTransmissionDateTime);
    });
  }
  function getAtpcoDateTimeString(latestCompletedTransmissionDateTime) {
    var atpcoDateString = rmMomentFormat(latestCompletedTransmissionDateTime, 'DATE_USER_SETTINGS');
    var atpcoTimeString = rmMomentFormat(latestCompletedTransmissionDateTime, 'TIME_USER_SETTINGS');
    return latestCompletedTransmissionDateTime.isValid() ? atpcoDateString + ', ' + atpcoTimeString : '';
  }
  function getSuccessfullyProcessedMessages(restmqMessage) {
    return _.get(_.last(restmqMessage.statuses), 'status') === 'FINISHED-PROCESSING';
  }
  function getMomentFromEventTransmissionDateTimeString(eventTransmissionDateTimeString) {
    return momentService.of(eventTransmissionDateTimeString, momentService.TYPE.LOCAL_DATE_TIME, 'MMDDYYhhmmss');
  }
  return {
    getLatestAtpcoTranmissionTime: getLatestAtpcoTranmissionTime
  };
};
LatestAtpcoTransmissionTimeService.$inject = ['MomentService', '$filter', 'Restangular', 'FeatureToggleService'];
module.exports = LatestAtpcoTransmissionTimeService;